import httpRequest from '@/utils/request.js';

/**
 * 获取当前用户主题色偏好
 * @returns {Promise} res.result = UserThemePreference 对象，无记录时为 null
 */
export const getThemePreference = () => httpRequest.httpGet({
    url: '/service/mine/theme'
});

/**
 * 保存当前用户主题色偏好
 * @param {String} themeColor 主题色 HEX 值，如 '#205FE7'
 * @returns {Promise} res.result = 保存后的 UserThemePreference 对象
 */
export const saveThemePreference = (themeColor) => httpRequest.httpPost('/service/mine/theme', {
    themeColor: themeColor
});
